import { useEffect } from 'react';
import { useReportClientInformation } from '@/hooks/profile/useReportClientInformation';
import { getFromLocalStorage } from '@/local-storage/utils';
import { useMsalAccount } from '@/auth/use-msal-account';

export const ReportClientInformation = () => {
  const { mutate } = useReportClientInformation();
  const { isMsalAccountReady } = useMsalAccount();

  useEffect(() => {
    if (isMsalAccountReady) {
      const savedLanguageCode = getFromLocalStorage('language') ?? 'nl';
      mutate(savedLanguageCode === 'en' ? 'en-US' : 'nl-NL');
    }
  }, [isMsalAccountReady]);

  return null;
};
